import { Correctness } from '@showbie-socrative/socrative-utils';

import axios from '../localAxios';
import { studentScoreURL } from './studentScoreURL';

export type UpsertStudentScoreBody = {
  score: number;
  correctness: Correctness;
};

export type UpsertStudentScoreResponse = {
  id: number;
  questionScoreId: number;
  studentId: number;
  score: number;
  correctness: Correctness;
  note: string;
  updatedDate: string;
};

export async function upsertStudentScore({
  questionScoreId,
  studentId,
  correctness,
  score,
  isRostered,
}: {
  questionScoreId: number;
  studentId: number;
  correctness: Correctness;
  score: number;
  isRostered: boolean;
}) {
  const url = studentScoreURL({
    isRostered: isRostered,
    questionScoreId: questionScoreId,
    studentId: studentId,
  });

  const body: UpsertStudentScoreBody = {
    correctness: correctness,
    score: score,
  };

  const { data } = await axios.put<UpsertStudentScoreResponse>(url.href, body);

  return data;
}
